import React from "react";
import { AssetHeader } from "./Assets.styled";
import RawMaterials from "../admin/components/config/rawMaterials/RawMaterials";
import DashboardLayout from "../Layout/DashboardLayout";

const RawMaterialsManagement = () => {
  return (
    <DashboardLayout pageTitle="Sales">
      <AssetHeader data-aos="fade-right">
        <h3>Raw Materials Management</h3>
      </AssetHeader>
      <RawMaterials />
    </DashboardLayout>
  );
};

export default RawMaterialsManagement;
